import { arrify } from '@client/new/helpers/general';
import { TypedValue } from '@client/new/helpers/types';
import { Row, RowProps } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import * as styles from './ScrollableContent.css';
import React from 'react';

export type ContentBase =
  | TypedValue<'title' | 'text' | 'bold' | 'video' | 'photo', string>
  | TypedValue<'link', { content: string; href: string }>;

export type ContentRow = Array<ContentBase> | ContentBase;

const ContentBaseRenderer = (p: ContentBase) => {
  switch (p.type) {
    case 'photo':
      return <img className={styles.media} src={p.value} />;
    case 'video':
      return (
        <video src={p.value} className={styles.media} muted loop controls />
      );
    case 'title':
      return (
        <Typography variant="bodyLarge" fontWeight="bold">
          {p.value}
        </Typography>
      );
    case 'bold':
      return <Typography fontWeight="bold">{p.value}</Typography>;
    case 'text':
      return <Typography fontWeight="normal">{p.value}</Typography>;
    case 'link':
      return (
        <Typography fontWeight="normal">
          <a
            href={p.value.href}
            target="_blank"
            style={{ textDecoration: 'underline' }}
            rel="noreferrer"
          >
            {p.value.content}
          </a>
        </Typography>
      );
  }
};

export const ContentRowRenderer = (p: {
  data: ContentRow;
  gap?: RowProps['gap'];
}) => (
  <Row gap={p.gap} responsive>
    {arrify(p.data).map((c, i) => (
      <ContentBaseRenderer {...c} key={i} />
    ))}
  </Row>
);
